import React from 'react';
import {Form} from 'react-bootstrap';

interface TopKResultSettingsProps {
    title: string;
    topK: number;
    isDisabled: boolean;
    onTopKChange: (value: number) => void;
}

const TopKResultSettings: React.FC<TopKResultSettingsProps> = ({
                                                                   title,
                                                                   topK,
                                                                   isDisabled,
                                                                   onTopKChange,
                                                               }) => (
    <div className="d-flex flex-column gap-2">
        <span>{title}</span>
        <Form.Control
            type="number"
            value={topK}
            disabled={isDisabled}
            onChange={(e) => onTopKChange(parseInt(e.target.value, 10))}
        />
    </div>
);

export default TopKResultSettings;
